import React, { Component, createRef, Fragment } from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isFunction, isMobile } from '@philips-internal/oswald-ui-utils';
import { Button } from '../button/button.js';
import './upload-area.css';
class UploadArea extends Component {
    constructor() {
        super(...arguments);
        this.inputRef = createRef();
        this.onDragOver = (event) => {
            event.preventDefault();
        };
        this.onDrop = (event) => {
            const { onChange } = this.props;
            event.preventDefault();
            if (!isFunction(onChange)) {
                return;
            }
            const data = event.dataTransfer.files;
            onChange(data);
        };
        this.onChange = (event) => {
            const { onChange } = this.props;
            if (!isFunction(onChange)) {
                return;
            }
            onChange(event.target.files);
        };
        this.onClick = () => {
            if (!this.inputRef.current) {
                return;
            }
            this.inputRef.current.files = null;
            this.inputRef.current.value = '';
            this.inputRef.current.click();
        };
    }
    renderDragNDropMessage() {
        const { acceptedFileTypes } = this.props;
        const dragNDropExpression = acceptedFileTypes
            ? 'tws.file-uploader.drag-and-drop-specific-file'
            : 'tws.file-uploader.drag-and-drop';
        if (isMobile()) {
            return null;
        }
        return (React.createElement(Fragment, null,
            React.createElement("span", { className: "c-file-uploader-modal__text" }, MessageService.translate(dragNDropExpression)),
            React.createElement("span", { className: "c-file-uploader-modal__text" }, MessageService.translate('tws.file-uploader.or'))));
    }
    renderAllowedTypesMessage() {
        const { acceptedFileTypes } = this.props;
        if (!acceptedFileTypes?.length) {
            return null;
        }
        return (React.createElement("span", { className: "c-file-uploader-modal__text allowed-types__text" }, MessageService.translate('tws.file-uploader-modal.allowed-file-types-message', { allowedTypes: acceptedFileTypes })));
    }
    renderTopMessage() {
        return isMobile() ? this.renderAllowedTypesMessage() : this.renderDragNDropMessage();
    }
    renderBottomMessage() {
        return isMobile() ? null : this.renderAllowedTypesMessage();
    }
    render() {
        const { acceptedFileTypes, buttonTheme, className, readOnly, multiple, value } = this.props;
        return (React.createElement("div", { className: "c-file-uploader-modal__container-drag-drop", draggable: "true", onDragOver: this.onDragOver, onDrop: this.onDrop },
            this.renderTopMessage(),
            React.createElement("input", { accept: acceptedFileTypes, className: className, multiple: multiple, onChange: this.onChange, ref: this.inputRef, type: "file" }),
            React.createElement(Button, { enabled: !readOnly, onClick: this.onClick, theme: buttonTheme, value: value }),
            this.renderBottomMessage()));
    }
}
export default UploadArea;
//# sourceMappingURL=upload-area.js.map